interface RowValueAccessor {
  getValue: (columnId: string) => unknown;
}

export function sumColumnValues(
  columnId: string,
  rows: RowValueAccessor[],
  precision = 2,
): number {
  const multiplier = Math.pow(10, precision);
  const sum = rows.reduce((acc, row) => {
    const value = Number(row.getValue(columnId));
    return acc + (Number.isFinite(value) ? Math.round(value * multiplier) : 0);
  }, 0);

  return sum / multiplier;
}
